import { render, staticRenderFns } from "./ContactsGroup.vue?vue&type=template&id=28027b78"
import script from "./ContactsGroup.vue?vue&type=script&lang=js"
export * from "./ContactsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports